import { mappedColors } from '@pixee/design-system'

/**
 * The Beacon views' semantic colours, mapped onto theme tokens so light and dark follow the app.
 *
 * - accent: the run's own voice — investigating, the pill, the budget.
 * - examined: a lens has looked at it.
 * - candidate: suspected and not yet ruled on.
 * - finding: kept after verification and triage.
 * - mapped / refuted: on the map but not examined; ruled out.
 */
export const beaconColors = {
  fg: mappedColors.neutral.neutral10,
  muted: mappedColors.neutral.neutral30,
  faint: mappedColors.neutral.neutral40,
  surface: mappedColors.surface.elevated,
  surface2: mappedColors.neutral.neutral70At50,
  border: mappedColors.neutral.neutral70,
  borderStrong: mappedColors.neutral.neutral60,
  accent: mappedColors.secondary.ether,
  accentSoft: mappedColors.secondary.etherAt20,
  accentFg: mappedColors.surface.elevated,
  mapped: mappedColors.neutral.neutral50,
  examined: mappedColors.secondary.halcyon,
  examinedSoft: mappedColors.secondary.halcyonAt20,
  candidate: mappedColors.secondary.haze,
  candidateSoft: mappedColors.secondary.hazeAt20,
  finding: mappedColors.secondary.spark,
  findingSoft: mappedColors.secondary.sparkAt20,
  refuted: mappedColors.neutral.neutral60,
  link: mappedColors.neutral.neutral70,
} as const
